/* =====================================================================
   monrow-pdp.js  --  product page behaviour.

   Everything here used to sit inline in product-template.liquid, which
   meant ~23 KB re-sent inside the HTML of every product page and never
   cached. As a file it is downloaded once per visitor and reused on
   every product they look at.

   Loaded with defer, after jQuery (which theme.liquid loads
   synchronously in the head), so $ is always available.

   Every block below already guards on its own element being present, so
   the file is safe on any product page even when that section is not
   rendered.
   ===================================================================== */

/* ---------------------------------------------------------------
   Flash-sale countdown (renders only on products tagged "flash_sales")
   (was product-template.liquid line 793)
   --------------------------------------------------------------- */
function startCountdown() {
  const timerDisplay = document.getElementById('timer');

  function updateTimer() {
    // Get current system time
    const now = new Date();

    // Calculate the next reset time (midnight of the next day)
    const nextReset = new Date();
    nextReset.setHours(24, 0, 0, 0); // Set to next midnight

    // Calculate time remaining in milliseconds
    const timeRemaining = nextReset - now;

    // Convert milliseconds to hours, minutes, seconds
    const hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeRemaining / (1000 * 60)) % 60);
    const seconds = Math.floor((timeRemaining / 1000) % 60);

    // Format time with leading zeros
    const formattedTime =
      `${hours.toString().padStart(2, '0')}:` +
      `${minutes.toString().padStart(2, '0')}:` +
      `${seconds.toString().padStart(2, '0')}`;

    // Update the display
    timerDisplay.textContent = formattedTime;
  }

  // Update immediately and then every second
  updateTimer();
  setInterval(updateTimer, 1000);
}

/* Two changes from the inline original:

   1. window.onload = ... ASSIGNED the handler, wiping out any other
      onload the theme or an app had set. addEventListener adds instead.
   2. This file now loads on every product page, not only inside the
      flash-sale block, so it has to check #timer exists before touching
      .textContent -- otherwise it throws on every other product. */
if (document.getElementById('timer')) {
  document.addEventListener('DOMContentLoaded', startCountdown);
}
                      

/* ---------------------------------------------------------------
   Related-products carousel
   (was product-template.liquid line 1052)
   --------------------------------------------------------------- */
jQuery(document).ready(function ($) {
  $('.related-products-carousel').owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 2,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 4,
      },
    },
  });
});
                      

/* ---------------------------------------------------------------
   Coupon card copy-to-clipboard
   (was product-template.liquid line 2369)
   --------------------------------------------------------------- */
/* Copy-to-clipboard for the coupon cards. Delegated on document, not bound
   per button: Owl clones the slides when the carousel loops, and a directly
   bound listener would not survive onto the clones. */
(function () {
  var COPY = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

  function copyText(text, done) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () { done(true); }, legacy);
      return;
    }
    legacy();
    function legacy() {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:absolute;left:-9999px;top:0;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      ta.setSelectionRange(0, text.length);
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      done(ok);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mnr-cpn__code');
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-code') || '';
    if (!code) return;
    copyText(code, function (ok) {
      if (!ok) return;
      if (btn._t) clearTimeout(btn._t);
      btn.classList.add('is-copied');
      btn.innerHTML = '<span class="mnr-cpn__code-text">Copied</span>' + TICK;
      btn._t = setTimeout(function () {
        btn.classList.remove('is-copied');
        btn.innerHTML = '<span class="mnr-cpn__code-text">' + code + '</span>' + COPY;
      }, 1600);
    });
  });
})();

/* ---------------------------------------------------------------
   Coupon strip (#offerSlider)
   (was product-template.liquid line 2418)
   --------------------------------------------------------------- */
jQuery(document).ready(function ($) {

  var $slider = $('#offerSlider');

  if (!$slider.length) {
    return;
  }

  /* how many offer images exist (counted before Owl wraps them) */
  var itemCount = $slider.children('.special-offer-item').length;

  if (!itemCount) {
    return;
  }

  /*
   * how many are visible at the current width
   * (must match the responsive block below)
   */
  function visibleCount() {
    return window.innerWidth >= 1000 ? 3 : 2;
  }

  /*
   * auto-scroll / loop / arrows only when there is
   * actually something off-screen to scroll to:
   *   desktop -> more than 3 images
   *   mobile  -> more than 2 images
   */
  var builtWithOverflow = null;

  /* Fewer than four coupons: the arrows are pointless -- on desktop all
     three are on screen already. Liquid has put .mnr-cpn-fit on the
     slider, which also drops the side gutters. Owl still gets drag on
     the narrow breakpoints, where two are visible and the third is not. */
  var fewCoupons = $slider.hasClass('mnr-cpn-fit');

  function buildOfferSlider() {

    var overflow = itemCount > visibleCount();

    /* nothing changed since the last build */
    if (builtWithOverflow === overflow) {
      return;
    }

    /* tear down the previous instance before rebuilding */
    if (builtWithOverflow !== null) {
      $slider.trigger('destroy.owl.carousel');
      $slider.removeClass('owl-loaded owl-hidden owl-drag');
      $slider.find('.owl-stage-outer').children().unwrap();
    }

    builtWithOverflow = overflow;

    $slider.owlCarousel({

      loop: overflow,

      nav: overflow && !fewCoupons,

      dots: false,

      margin: 10,

      autoplay: overflow,

      autoplayTimeout: 3500,

      autoplaySpeed: 600,

      autoplayHoverPause: true,

      mouseDrag: overflow,

      touchDrag: overflow,

      pullDrag: overflow,

      navText: [
        '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></span>',
        '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></span>'
      ],

      responsive: {

        0: {
          items: 2
        },

        600: {
          items: 2
        },

        1000: {
          items: 3
        }

      }

    });
  }

  buildOfferSlider();

  /* re-check when the viewport crosses the 1000px breakpoint */
  /* ------------------------------------------------------------------
     CLS. On a phone, scrolling collapses and expands the browser's own
     chrome, and every one of those fires window resize -- with the SAME
     width. Rebuilding the carousel on those destroyed and re-created the
     Owl stage mid-scroll, collapsing the block to 0 and snapping it back
     (measured 0.0155 at 7974ms). The only reason to rebuild is a
     breakpoint change, and breakpoints are width-only, so compare width
     and ignore height-only resizes.
     ------------------------------------------------------------------ */
  var offerResizeTimer;
  var offerLastWidth = window.innerWidth;

  $(window).on('resize', function () {

    if (window.innerWidth === offerLastWidth) return;
    offerLastWidth = window.innerWidth;

    clearTimeout(offerResizeTimer);

    offerResizeTimer = setTimeout(buildOfferSlider, 200);

  });

});

/* ---------------------------------------------------------------
   Best-offer calculator (#monrowBestOffers)
   (was product-template.liquid line 2550)
   --------------------------------------------------------------- */
jQuery(document).ready(function ($) {

  var $wrap    = $('.monrow-best-offers-section');
  var $carousel = $('#monrowBestOffers');

  if (!$carousel.length) {
    return;
  }

  var offerData = window.monrowBestOfferData;

  if (!offerData || !offerData.productPrice) {
    $wrap.hide();
    return;
  }

  /*
   * =========================================
   * SHOW OFFERS THE SHOPPER CANNOT REACH YET
   *
   * Some offers need a bigger basket than this
   * one product. EXTRA300 needs a Rs1,999 order,
   * so on a Rs1,649 shoe the discounted total
   * (Rs1,699) is MORE than the shoe alone.
   *
   *   false -> hide it. Never shows a "Get it
   *            for" figure above the product's
   *            own price.
   *
   *   true  -> show it as a basket nudge:
   *            "Add Rs350 more" + "On orders
   *            above Rs1,999" + "Save Rs300",
   *            so the shopper knows exactly what
   *            to do to unlock it.
   *
   * Offers the shopper CAN already use are
   * unaffected either way.
   * =========================================
   */

  var SHOW_UNREACHABLE_OFFERS = true;

  var productPrice = parseFloat(offerData.productPrice);
  var offers       = offerData.offers || [];

  if (!productPrice || !offers.length) {
    $wrap.hide();
    return;
  }

  /*
   * =========================================
   * MONEY FORMAT  (1614 -> 1,614)
   * =========================================
   */

  function money(amount) {

    var value = Math.round(amount);

    try {
      return value.toLocaleString('en-IN');
    } catch (e) {
      return String(value);
    }
  }


  /*
   * =========================================
   * CALCULATE ONE OFFER
   *
   * - offer applies to the product itself when
   *   productPrice >= minimum
   *
   * - when the product alone does NOT reach the
   *   minimum order value, the price is calculated
   *   on the QUALIFYING order value (minimum),
   *   never on the product price
   *   e.g. 2199 - 400 = 1799*
   * =========================================
   */

  function calculateOffer(offer) {

    if (!offer || !offer.code) {
      return null;
    }

    var minimum    = parseFloat(offer.minimum) || 0;
    var value      = parseFloat(offer.value) || 0;
    var applicable = productPrice >= minimum;

    /* base = value the discount is calculated on */
    var base = applicable ? productPrice : minimum;

    var discount = 0;

    if (offer.type === 'percentage') {
      discount = base * (value / 100);
    } else if (offer.type === 'fixed') {
      discount = Math.min(value, base);
    } else {
      return null;
    }

    if (discount <= 0) {
      return null;
    }

    var finalPrice = base - discount;

    /*
     * "beatsPrice" = taking this offer leaves the shopper paying
     * LESS than this product costs on its own. When it does not,
     * quoting a "Get it for" figure would look absurd
     * (Rs1,699 printed above a Rs1,649 shoe), so such offers are
     * either dropped or reframed as a nudge -- see the switch above.
     */

    var beatsPrice = applicable ||
                     Math.round(finalPrice) < Math.round(productPrice);

    if (!beatsPrice && !SHOW_UNREACHABLE_OFFERS) {
      return null;
    }

    return {
      code       : offer.code,
      type       : offer.type,
      value      : value,
      minimum    : minimum,
      applicable : applicable,
      beatsPrice : beatsPrice,
      /* how much more basket is needed to unlock it */
      shortfall  : Math.max(0, minimum - productPrice),
      discount   : discount,
      finalPrice : finalPrice
    };
  }


  /*
   * =========================================
   * CALCULATE ALL OFFERS
   * =========================================
   */

  var calculatedOffers = [];

  offers.forEach(function (offer) {

    var calculated = calculateOffer(offer);

    if (calculated) {
      calculatedOffers.push(calculated);
    }

  });

  if (!calculatedOffers.length) {
    $wrap.hide();
    return;
  }


  /*
   * =========================================
   * SORTING
   *
   * 1. offers applicable to this product first
   * 2. within each group, highest saving first
   *
   * (a big minimum-order offer never jumps ahead
   *  of a smaller offer the customer can use now)
   * =========================================
   */

  calculatedOffers.sort(function (a, b) {

    /* 1. offers usable right now, biggest saving first */
    if (a.applicable !== b.applicable) {
      return a.applicable ? -1 : 1;
    }
    if (a.applicable) {
      return b.discount - a.discount;
    }

    /* 2. then min-order offers that still beat the product price */
    if (a.beatsPrice !== b.beatsPrice) {
      return a.beatsPrice ? -1 : 1;
    }

    /* 3. then pure nudges, the closest to qualifying first --
          "add Rs100 more" is a better prompt than "add Rs850 more" */
    if (a.shortfall !== b.shortfall) {
      return a.shortfall - b.shortfall;
    }

    return b.discount - a.discount;

  });


  /*
   * =========================================
   * HOW MANY CARDS
   * =========================================
   */

  var MAX_CARDS = 2;

  calculatedOffers = calculatedOffers.slice(0, MAX_CARDS);


  /*
   * =========================================
   * CREATE OFFER CARDS
   * =========================================
   */

  var copyIcon =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
    'aria-hidden="true" focusable="false">' +
    '<rect x="9" y="9" width="12" height="12" rx="2"></rect>' +
    '<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>' +
    '</svg>';

  var tagIcon =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" ' +
    'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" ' +
    'stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>' +
    '<line x1="7" y1="7" x2="7.01" y2="7"></line>' +
    '</svg>';

  calculatedOffers.forEach(function (offer) {

    /* Three cases, three headlines. The lead word stays dark and the
       number is orange, so they are always two separate spans. */

    var leadText, amountText, trailText = '', minimumText = '';

    if (offer.applicable) {

      /* usable on this product, on its own */
      leadText   = 'Get it for ';
      amountText = '&#8377;' + money(offer.finalPrice);

    } else if (offer.beatsPrice) {

      /* needs a bigger basket, but the total still comes in under
         this product's price -- quote it, flagged with * */
      leadText    = 'Get it for ';
      amountText  = '&#8377;' + money(offer.finalPrice) + '*';
      minimumText = 'On orders above &#8377;' + money(offer.minimum);

    } else {

      /* pure nudge: tell them exactly how much more to add */
      leadText    = 'Add ';
      amountText  = '&#8377;' + money(offer.shortfall);
      trailText   = ' more';
      minimumText = 'On orders above &#8377;' + money(offer.minimum);
    }

    var card =
      '<div class="item">' +
        '<div class="monrow-best-offer-card">' +

          '<div class="monrow-best-offer-icon">' + tagIcon + '</div>' +

          '<div class="monrow-best-offer-content">' +

            '<div class="monrow-best-offer-price">' +
              leadText +
              '<span class="monrow-best-offer-amount">' + amountText + '</span>' +
              trailText +
            '</div>' +

            '<div class="monrow-best-offer-description">' +
              'With ' +
              '<button type="button" class="monrow-best-offer-code"' +
                ' data-code="' + offer.code + '"' +
                ' aria-label="Copy discount code ' + offer.code + '">' +
                '<span class="monrow-best-offer-code-text">' + offer.code + '</span>' +
                copyIcon +
              '</button>' +
              ' + 5% Prepaid Discount*' +
            '</div>' +

            (minimumText
              ? '<div class="monrow-best-offer-minimum">' + minimumText + '</div>'
              : '') +

          '</div>' +

          '<div class="monrow-best-offer-divider"></div>' +

          '<div class="monrow-best-offer-saving">' +
            '<span class="monrow-best-offer-saving-label">Save</span>' +
            '<span class="monrow-best-offer-saving-amount">&#8377;' +
              money(offer.discount) +
            '</span>' +
          '</div>' +

        '</div>' +
      '</div>';

    $carousel.append(card);

  });


  /*
   * =========================================
   * COPY THE CODE
   *
   * navigator.clipboard needs a secure context.
   * Shopify is HTTPS so it normally works, but a
   * theme preview inside an iframe, or an older
   * browser, can still refuse -- hence the
   * execCommand fallback rather than a silent
   * failure the shopper cannot see.
   * =========================================
   */

  function copyText(text, done) {

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(
        function () { done(true); },
        function () { legacyCopy(); }
      );
      return;
    }

    legacyCopy();

    function legacyCopy() {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        ta.setSelectionRange(0, text.length);
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        done(!!ok);
      } catch (e) {
        done(false);
      }
    }
  }

  /* delegated, so it keeps working on the slides Owl clones for looping */
  $carousel.on('click', '.monrow-best-offer-code', function (e) {

    e.preventDefault();
    e.stopPropagation();

    var button = this;
    var code   = button.getAttribute('data-code') || '';
    var label  = button.querySelector('.monrow-best-offer-code-text');

    if (!label) {
      return;
    }

    copyText(code, function (ok) {

      label.textContent = ok ? 'Copied' : 'Copy failed';

      if (ok) {
        button.classList.add('is-copied');
      }

      clearTimeout(button.monrowCopyTimer);

      button.monrowCopyTimer = setTimeout(function () {
        label.textContent = code;
        button.classList.remove('is-copied');
      }, 1600);

    });
  });


  /*
   * =========================================
   * INITIALIZE TOP OFFER CAROUSEL
   * ONE card at a time on every breakpoint
   * =========================================
   */

  var cardCount = $carousel.find('.item').length;

  if (!cardCount) {
    $wrap.hide();
    return;
  }

  if (cardCount < 2) {
    $wrap.addClass('monrow-single-offer');
  }

  $carousel.owlCarousel({

    /* 1 card is visible, so anything past the first can auto-scroll */
    loop: cardCount > 1,

    nav: cardCount > 1,

    dots: cardCount > 1,

    autoplay: cardCount > 1,

    autoplayTimeout: 4500,

    autoplaySpeed: 600,

    autoplayHoverPause: true,

    margin: 0,

    items: 1,

    mouseDrag: true,

    touchDrag: true,

    pullDrag: true,

    autoHeight: true,

    navText: [
      '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></span>',
      '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></span>'
    ],

    responsive: {
      0:    { items: 1 },
      600:  { items: 1 },
      1000: { items: 1 }
    }

  });


  /*
   * =========================================
   * KEEP THE DISCLAIMER ON ONE LINE
   *
   * The sentence is ~94 characters, so whether it
   * fits on one line depends on the column width
   * AND on the theme's font metrics. Rather than
   * hard-code a size that happens to work on one
   * layout, measure the real thing and scale the
   * text down to fit -- never below 8px, and never
   * above whatever the stylesheet asks for.
   *
   * Below 768px the strip stacks, so wrapping there
   * is the intended layout and this does nothing.
   * =========================================
   */

  var $infoNote = $('.monrow-best-offers-info-note');

  function fitInfoNote() {

    if (!$infoNote.length) {
      return;
    }

    var node = $infoNote[0];

    /* always start from the stylesheet value, so widening
       the window can give the text its size back */
    $infoNote.css('font-size', '');

    if (window.innerWidth < 768) {
      return;
    }

    var styles = window.getComputedStyle(node);
    var base   = parseFloat(styles.fontSize);

    if (!base) {
      return;
    }

    /* usable width = content box, minus the rule's padding */
    var available = node.clientWidth
                  - parseFloat(styles.paddingLeft || 0)
                  - parseFloat(styles.paddingRight || 0);

    if (!(available > 0)) {
      return;
    }

    /* width the sentence wants on a single line, in the real font */
    var probe = document.createElement('span');

    probe.style.position   = 'absolute';
    probe.style.left       = '-9999px';
    probe.style.top        = '0';
    probe.style.visibility = 'hidden';
    probe.style.whiteSpace = 'nowrap';
    probe.style.font       = styles.font || (styles.fontWeight + ' ' + styles.fontSize + '/' + styles.lineHeight + ' ' + styles.fontFamily);
    probe.style.letterSpacing = styles.letterSpacing;

    probe.textContent = ($infoNote.text() || '').replace(/\s+/g, ' ').trim();

    document.body.appendChild(probe);

    var needed = probe.getBoundingClientRect().width;

    document.body.removeChild(probe);

    if (!needed || needed <= available) {
      return;
    }

    /* shrink proportionally, then shave a hair so rounding
       can never tip it onto a second line */
    var size = (base * available / needed) - 0.15;

    size = Math.max(8, Math.round(size * 100) / 100);

    if (size < base) {
      $infoNote.css('font-size', size + 'px');
    }
  }

  fitInfoNote();

  var infoResizeTimer;
  var infoLastWidth = window.innerWidth;

  $(window).on('resize', function () {

    /* Same reasoning as the offer slider above: height-only resizes are
       the phone's URL bar, and re-fitting the note on those made the
       tax strip collapse from 90px to 12px mid-scroll. */
    if (window.innerWidth === infoLastWidth) return;
    infoLastWidth = window.innerWidth;

    clearTimeout(infoResizeTimer);

    infoResizeTimer = setTimeout(fitInfoNote, 150);

  });

});